module.exports = __webpack_public_path__ + "img/icon-zuzhigoujia.9cfb41bd.svg";